type ICopyIcon = {
  color?: string;
};
export const CopyIcon = (props: ICopyIcon) => {
  const { color = '#222530' } = props;
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M4.6665 10.666C3.56193 10.666 2.6665 9.77059 2.6665 8.66602V4.66602C2.6665 3.56145 3.56193 2.66602 4.6665 2.66602H8.6665C9.77107 2.66602 10.6665 3.56145 10.6665 4.66602M11.3332 13.3327H6.6665C5.56194 13.3327 4.6665 12.4373 4.6665 11.3327L4.66651 6.66602C4.66651 5.56145 5.56194 4.66602 6.66651 4.66602L11.3332 4.66602C12.4377 4.66602 13.3332 5.56145 13.3332 6.66602L13.3332 11.3327C13.3332 12.4373 12.4377 13.3327 11.3332 13.3327Z"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
